import { render, staticRenderFns } from "./unloadingReports.vue?vue&type=template&id=04359534&scoped=true"
import script from "./unloadingReports.vue?vue&type=script&lang=js"
export * from "./unloadingReports.vue?vue&type=script&lang=js"
import style0 from "./unloadingReports.vue?vue&type=style&index=0&id=04359534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04359534",
  null
  
)

export default component.exports